export const CREATE_VENDOR = 'CREATE_VENDOR';
export const UPDATE_VENDOR = 'UPDATE_VENDOR';
export const UPDATE_AGENCY = 'UPDATE_AGENCY';
export const LOAD_AGENCIES_TO_STORE = 'LOAD_AGENCIES_TO_STORE';
export const TOGGLE_IS_PROCESSING = 'TOGGLE_IS_PROCESSING';
export const SAVE_VENDOR_INFO_TO_STORE = 'SAVE_VENDOR_INFO_TO_STORE';
export const SAVE_AGENCY_INFO_TO_STORE = 'SAVE_AGENCY_INFO_TO_STORE';
